import React from 'react';
import { colour } from '../../styles/GlobalStyles';

// Filled front-on train/light-rail car — matches the filled style of Car.js/Bus.js.
// Used as the mode token on a rail stop row in the co-living Transit section. Sized via
// the `size` prop (defaults to 16 to match the other icons); colour via `fill`.
//
// `knockout` is the colour of the window/door punched out of the body — it must match
// whatever sits behind the icon, so it defaults to the analysis card's own background.
function Train(props) {
    const fill = props.fill;
    const knockout = props.knockout || colour.gray01;
    const className = props.className;
    const size = props.size || 16;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            {/* body — rounded top, square shoulders, so it reads apart from the bus */}
            <path d="M5 8 Q5 3 12 3 Q19 3 19 8 L19 17 Q19 19 17 19 L7 19 Q5 19 5 17 Z" fill={fill} />
            {/* windscreen */}
            <rect x="7.5" y="6.5" width="9" height="5" rx="1" fill={knockout} />
            {/* door split */}
            <rect x="11.4" y="13" width="1.2" height="4" fill={knockout} />
            {/* rails */}
            <rect x="4" y="20.4" width="16" height="1.4" rx="0.7" fill={fill} />
        </svg>
    );
}

export default Train;
